<template>
  <input
    type="number"
    v-bind:value="Number((this.value * 100).toFixed(2))"
    v-on:input="$emit('change', $event.target.value / 100)"
  />
</template>

<script>
export default {
  name: "RoePercentInput",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: Number
  }
};
</script>
